import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=3930eb80&scoped=true&"
import script from "./Hall.vue?vue&type=script&lang=js&"
export * from "./Hall.vue?vue&type=script&lang=js&"
import style0 from "./Hall.vue?vue&type=style&index=0&id=3930eb80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930eb80",
  null
  
)

export default component.exports